/* eslint-disable @typescript-eslint/no-explicit-any */
import { useState } from "react";
import { Popover, Typography } from "antd";
import PopOverCrew from "./PopOverCrew";

function CrewCard(props: any) {
  const {
    column,
    crewDrop,
    selectedDate,
    setLoading,
    loading,
    isWeekend,
    hideEditIcon,
    weekStartDate,
  } = props;

  // const isToday = selectedDate
  //   ? new Date(selectedDate).toDateString() === new Date().toDateString()
  //   : false;

  const [open, setOpen] = useState(false);
  const [editCrew, setEditCrew] = useState(false);

  const handleOpenChange = (newOpen: boolean) => {
    setEditCrew(false);
    setOpen(newOpen);
  };
  let mergeCrewArray: any[] = [];

  if (column?.crewMembers?.length > 0) {
    mergeCrewArray = [
      ...(column?.crewLeader ? [{ ...column.crewLeader, type: "leader" }] : []),
      ...(column?.crewMembers ?? []),
    ];
  }
  // console.log("mergeCrewArray in crew card---", mergeCrewArray, column);
  return (
    <div
      className="column_info_item"
      style={{
        width: "76px",
        marginLeft: "auto",
        cursor: isWeekend ? "default" : "pointer",
        height: isWeekend ? "auto" : "50px",
      }}
    >
      {isWeekend ? (
        <Typography.Text
          type="secondary"
          style={{
            fontSize: "12px",
            color: "#151718",
            display: "block",
            textAlign: "left",
            fontWeight: 600,
          }}
        >
          N/A
        </Typography.Text>
      ) : column?.crewAttendances?.length > 0 ? (
        <Popover
          trigger="click"
          arrow={false}
          placement="bottomLeft"
          open={open}
          onOpenChange={handleOpenChange}
          styles={{
            root: {
              width: "330px",
            },
          }}
          content={
            <PopOverCrew
              column={column}
              editCrew={editCrew}
              crewDrop={crewDrop}
              setEditCrew={setEditCrew}
              crewArray={column?.crewAttendances}
              selectedDate={selectedDate}
              setLoading={setLoading}
              loading={loading}
              hideEditIcon={hideEditIcon}
              weekStartDate={weekStartDate}
            />
          }
        >
          <span
            style={{
              display: "flex",
              alignItems: "center",
              gap: "4px",
              marginBottom: "4px",
            }}
          >
            Crew
          </span>

          <div className="crewDotsWrapper">
            {column?.crewAttendances?.length || 0}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
                gap: "4px",
                width: "100%",
                paddingLeft: "6px",
                flexWrap: "wrap",
              }}
            >
              {column?.crewAttendances?.map((member: any) =>
                member?.status === "late_punch_in" ||
                member?.status === "punch_in" ? (
                  <span
                    key={member.id}
                    className="crewDots"
                    style={{ backgroundColor: "#00A07D" }}
                  />
                ) : member?.status === "no_show" ? (
                  <span
                    key={member.id}
                    className="crewDots"
                    style={{ backgroundColor: "#D33D3D" }}
                  />
                ) : (
                  <span
                    key={member.id}
                    className="crewDots"
                    style={{ backgroundColor: "#DEE5E6" }}
                  />
                )
              )}
            </div>
          </div>
        </Popover>
      ) : (
        <Popover
          trigger="click"
          arrow={false}
          placement="bottomLeft"
          open={open}
          onOpenChange={handleOpenChange}
          styles={{
            root: {
              width: "330px",
            },
          }}
          content={
            <PopOverCrew
              column={column}
              crewDrop={crewDrop}
              setEditCrew={setEditCrew}
              crewArray={mergeCrewArray}
              selectedDate={selectedDate}
              setLoading={setLoading}
              loading={loading}
              weekStartDate={weekStartDate}
            />
          }
        >
          <span
            style={{
              display: "flex",
              alignItems: "center",
              gap: "4px",
              marginBottom: "4px",
            }}
          >
            Crew
          </span>

          <div className="crewDotsWrapper">
            {mergeCrewArray?.length || 0}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
                gap: "4px",
                width: "100%",
                paddingLeft: "6px",
                flexWrap: "wrap",
              }}
            >
              {mergeCrewArray?.map((member: any) => (
                <span
                  key={member.id}
                  className="crewDots"
                  style={{ backgroundColor: "#DEE5E6" }}
                />
              ))}
            </div>
          </div>
        </Popover>
      )}
    </div>
  );
}

export default CrewCard;
